import './storyTile.scss';
import { BaseComponent } from '../baseComponent';
import { ComponentStates } from '@/models/componentStates';
import { viewport } from '@/modules/includeMedia';
import { ComponentEvents } from '@/models/events';

export default class extends BaseComponent {
  constructor(el: HTMLElement) {
    super(el);
    this.visibleTrigger = 20;
    this.el.addEventListener(ComponentEvents.READY, this.init.bind(this));
  }

  public init() {
    if (!this.el.dataset.spy) {
      this.revealElement();
    }

    const filter = this.el.querySelector('.filter');

    filter && this.addFilterToggleHandler(filter);
  }

  private addFilterToggleHandler(filter: Element): void {
    const mobileToggle = filter.querySelector('.mobile-filter-toggle');

    if (mobileToggle && !viewport.greaterThan('phone')) {
      const toggleHeight = mobileToggle.clientHeight;
      const filterHeight = filter.clientHeight;
      filter.setAttribute('style', `max-height: ${toggleHeight}px`);

      mobileToggle.addEventListener('click', () => {
        filter.classList.toggle(ComponentStates.OPEN);
        if (filter.classList.contains(ComponentStates.OPEN)) {
          filter.setAttribute('style', `max-height: ${filterHeight}px`);
        } else {
          filter.setAttribute('style', `max-height: ${toggleHeight}px`);
        }
      });
    }
  }
}
